import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@/components/layout/Page';
import { Section } from '@/components/layout/Section';
import { PageHeader } from '@/components/composed/PageHeader';
import { RouteError } from '@/components/composed/RouteError';
import { NotFound } from '@/components/composed/NotFound';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import {
  PortalSummaryCards,
  PortalTransactionsTable,
  portalSummaryQuery,
  portalTransactionsQuery,
} from '@/features/portal';

/*
 * Portal summary landing (mock-first first pass — see ADR 0009). The one live
 * portal page. Thin route: the loader primes the summary + transactions
 * queries, the component composes the feature's display pieces. Data feeds from
 * the mock boundary (features/portal/api) in this pass.
 */
export const Route = createFileRoute('/_portal/portal/summary')({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(portalSummaryQuery()),
      context.queryClient.ensureQueryData(portalTransactionsQuery()),
    ]);
  },
  component: PortalSummaryPage,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function PortalSummaryPage() {
  useDocumentTitle('Pay My Bill');
  return (
    <Page bleed>
      <PageHeader title="Pay My Bill" />
      <PortalSummaryCards />
      <Section>
        <h2 className="text-lg font-semibold">Recent Transactions</h2>
        {/* surface: the table renders as a white panel on the muted content
            backdrop, matching the summary cards above it. */}
        <PortalTransactionsTable />
      </Section>
    </Page>
  );
}
